import { useCallback } from 'react';
import { useAsyncValue } from '../../../contexts/field-async-value';
import { useTemporaryValue } from '../../../contexts/field-temporary-value-context';
import { useUploadSignature } from './use-upload-signature';
import { isDataUrl, processDataUrl } from '../utils/data-url';
export const useUploadSignatureOnSubmit = _ref => {
  let {
    rtl,
    target
  } = _ref;
  const [, setTemporaryFile] = useTemporaryValue(target);
  const uploadSignatureFile = useUploadSignature();
  const uploadSignature = useCallback(async oldValue => {
    const dataUrl = oldValue == null ? void 0 : oldValue[0].url;
    if (isDataUrl(dataUrl)) {
      const signatureFile = await processDataUrl(dataUrl, rtl);
      if (signatureFile) {
        const uploadedValue = await uploadSignatureFile(signatureFile);
        return [uploadedValue];
      } else {
        // The signature is empty ( example the user choose a fully transparent image )
        setTemporaryFile(undefined);
        return null;
      }
    }
    return oldValue;
  }, [rtl, setTemporaryFile, uploadSignatureFile]);
  useAsyncValue(target, uploadSignature);
};
//# sourceMappingURL=use-upload-signature-on-submit.js.map